"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (params) {
    params = params || {};

    var self = {};

    var requestId = 0;

    self.cancel = function () {
        ++requestId;
    };

    self.getCallbackNoCancel = function (callback) {
        return function (expectedRequestId) {
            // Closure is used to bind current requestId
            return function (e) {
                // Ignore old searches
                if (requestId !== expectedRequestId) {
                    return;
                }

                callback(e);
            };
        }(requestId);
    };

    self.getCallback = function (callback) {
        self.cancel();
        return self.getCallbackNoCancel(callback);
    };

    return self;
};

;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/FreshRequestFilter.js
// module id = 467
// module chunks = 0